import script from "./UserPrelevementsMensuels.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserPrelevementsMensuels.vue?vue&type=script&setup=true&lang=ts"

import "./UserPrelevementsMensuels.vue?vue&type=style&index=0&id=682fa648&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-682fa648"]])

export default __exports__